import { computed, observable } from 'mobx';
import { compact } from 'lodash';
import Abstract from './abstract';

export class Auth extends Abstract {
  @observable public ready = false;

  @computed get storePrefix() {
    const { platform } = nx.hashlize();
    return compact(['kellis-ng', platform || 'internal', this.schoolId]).join(':');
  }

  set account(value: any) {
    nx.$storage.local = { 'alo7-account': value };
  }

  get account() {
    return nx.get(nx.$storage.local, 'alo7-account');
  }

  get schoolId() {
    const { schoolId } = nx.hashlize();
    if (this.root.isInternal) return '';
    if (this.root.isEmptyExtSchoolId) return -1;
    return parseInt(schoolId, 10) || '';
  }

  public init() {
    nx.set(window, 'alo7Account', { permissions: {} });

    const { referer, subuserId, platform, access_token } = nx.hashlize();
    const isAOSP = referer === 'aosp';
    const schoolId = this.schoolId;
    const param = isAOSP
      ? { aospSubUserId: subuserId, token: access_token, referer, platform, schoolId }
      : null;

    nx.$storage.config({ prefix: this.storePrefix });
    // merge to memory
    nx.mix(alo7Account, this.account, param);
    // save to localStorage
    this.account = alo7Account;
  }
}
